module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill green"
  }, [_c('polygon', {
    attrs: {
      "points": "5 29.7421167 16.4672451 17.6162426 29.2382412 31.1896762 53.9432575 5 65 16.7345845 28.8929948 55"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3268c177"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/correct.vue
// module id = 607
// module chunks = 1